import { advancedFilterCondition } from './advancedFilterCondition';
import { dateFilterOptions } from './dateFilterOptions';

const fulfillmentOrderStatus = {
	returned: 'returned',
	assigned: 'assigned',
	palletized: 'palletized',
	entered: 'entered',
	picking: 'picking',
	packaged: 'packaged',
	exitScan: 'exit%20scan',
	reassigned: 'reassigned',
	replaced: 'replaced',
	notReceived: 'not%20received',
	canceled: 'canceled',
	labelCreated: 'label%20created',
	shippedExternally: 'shipped%20externally',
};

const onAssignStatuses = [fulfillmentOrderStatus.entered];

const onHoldStatuses = [
	fulfillmentOrderStatus.entered,
	fulfillmentOrderStatus.assigned,
	fulfillmentOrderStatus.picking,
	fulfillmentOrderStatus.labelCreated,
	fulfillmentOrderStatus.packaged,
	fulfillmentOrderStatus.palletized,
];

const onSplitFulfillmentOrderStatuses = [
	fulfillmentOrderStatus.picking,
	fulfillmentOrderStatus.assigned,
	fulfillmentOrderStatus.entered,
];

const onCancelStatuses = [
	fulfillmentOrderStatus.entered,
	fulfillmentOrderStatus.assigned,
	fulfillmentOrderStatus.picking,
	fulfillmentOrderStatus.labelCreated,
	fulfillmentOrderStatus.packaged,
	fulfillmentOrderStatus.palletized,
	fulfillmentOrderStatus.reassigned,
];

const onCarrierServiceChangeStatuses = [fulfillmentOrderStatus.assigned, fulfillmentOrderStatus.picking];

const onUpdateBuyShippingStatuses = [
	fulfillmentOrderStatus.assigned,
	fulfillmentOrderStatus.picking,
	fulfillmentOrderStatus.labelCreated,
	fulfillmentOrderStatus.packaged,
	fulfillmentOrderStatus.palletized,
];

const onChangeShippingStatuses = [
	fulfillmentOrderStatus.assigned,
	fulfillmentOrderStatus.picking,
	fulfillmentOrderStatus.labelCreated,
	fulfillmentOrderStatus.packaged,
	fulfillmentOrderStatus.palletized,
];

const onStatusChangeStatuses = [fulfillmentOrderStatus.exitScan];

const onPrintLabelStatuses = [
	fulfillmentOrderStatus.labelCreated,
	fulfillmentOrderStatus.packaged,
	fulfillmentOrderStatus.palletized,
	fulfillmentOrderStatus.exitScan,
	fulfillmentOrderStatus.assigned,
	fulfillmentOrderStatus.picking,
];

const onPrintPackingSlipStatuses = [
	fulfillmentOrderStatus.labelCreated,
	fulfillmentOrderStatus.packaged,
	fulfillmentOrderStatus.palletized,
	fulfillmentOrderStatus.exitScan,
];

const onPullLabelStatuses = [fulfillmentOrderStatus.assigned, fulfillmentOrderStatus.picking];

const onNeverShippedStatuses = [fulfillmentOrderStatus.exitScan];

const onProductionModeStatuses = [fulfillmentOrderStatus.assigned, fulfillmentOrderStatus.picking];

const onMarkAsShippedStatuses = [
	fulfillmentOrderStatus.entered,
	fulfillmentOrderStatus.assigned,
	fulfillmentOrderStatus.picking,
	fulfillmentOrderStatus.labelCreated,
	fulfillmentOrderStatus.packaged,
	fulfillmentOrderStatus.palletized,
];

const voidLabelStatuses = [
	fulfillmentOrderStatus.assigned,
	fulfillmentOrderStatus.picking,
	fulfillmentOrderStatus.labelCreated,
	fulfillmentOrderStatus.packaged,
	fulfillmentOrderStatus.palletized,
];

const onReoptimizeStatuses = [fulfillmentOrderStatus.assigned];

const initialOrderFilteringStatuses = [
	'Assigned',
	'Canceled',
	'Entered',
	'Label Created',
	'Not Received',
	'Packaged',
	'Palletized',
	'Picking',
	'Reassigned',
	'Replaced',
	'Returned',
	'Shipped Externally',
];

const initialDateFilterOption =
	//should I create enums from these
	{
		value: 'last90Days',
		label: 'Last 90 Days',
	};
const initialAdvancedSearchFilterSetup = [
	{
		condition: 4,
		fieldName: 'fulfillmentOrderStatus',
		filterValue: [
			{ value: 'Assigned' },
			{ value: 'Canceled' },
			{ value: 'Entered' },
			{ value: 'Label Created' },
			{ value: 'Not Received' },
			{ value: 'Packaged' },
			{ value: 'Palletized' },
			{ value: 'Picking' },
			{ value: 'Reassigned' },
			{ value: 'Replaced' },
			{ value: 'Returned' },
			{ value: 'Shipped Externally' },
		],
	},
];

export {
	fulfillmentOrderStatus,
	onAssignStatuses,
	onHoldStatuses,
	onCancelStatuses,
	onCarrierServiceChangeStatuses,
	onUpdateBuyShippingStatuses,
	onChangeShippingStatuses,
	onStatusChangeStatuses,
	onPrintLabelStatuses,
	onPrintPackingSlipStatuses,
	onPullLabelStatuses,
	onNeverShippedStatuses,
	onMarkAsShippedStatuses,
	onProductionModeStatuses,
	initialOrderFilteringStatuses,
	initialAdvancedSearchFilterSetup,
	voidLabelStatuses,
	onSplitFulfillmentOrderStatuses,
	initialDateFilterOption,
	onReoptimizeStatuses,
};



// WEBPACK FOOTER //
// ./src/common/constants/fulfillmentOrderConstants.js